module.exports = __webpack_public_path__ + "img/en.83b06584.png";